<template>
  <div class="p-5">
    <p>
      INTISAI is an online video streaming platform owned by
      INTISAI Entertainment Private Limited, INTISAI
      currently offers over 100,000 hours of TV content and movies across 9 languages, and every major sport covered live.
      Highly evolved video streaming technology and a high attention to quality of experience across devices and platforms, make INTSAI the most complete
      video destination for Over The Top (OTT) video consumers.
      Reach out!
    </p>
    <div align="center" class="mt-8">
      <v-row>
        <v-col class="part">
          <v-card>
            <v-card-text>
              <h6 class="text-muted">
                <v-icon class="fa">mdi-account-convert
                </v-icon>
                Helpline
              </h6>
              <h4>{{Helpline}}</h4>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col class="part">
          <v-card>
            <v-card-text>
              <h6 class="text-muted">
                <i class="fa fa-envelope" /> Email ID
              </h6>
              <h4>{{Email_ID}}</h4>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col class="part">
          <v-card>
            <v-card-text>
              <h6 class="text-muted">
              <i class="fas fa-map-marker-alt" style="color:rgb(121, 153, 179)"></i>Location
              </h6>
              <h4>{{Location}}</h4>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      Location: "Tisai House, 3rdFloor, Pune Link Road, Tisgaon Naka, Kalyan (E)- 421306",
      Email_ID: "tisai.darpita@gmail.com",
      Helpline: "+91-869-291-1111"
    };
  }
};
</script>
<style scoped>
  .part {
    padding: 20px;
  }
</style>